// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e617c6510ed50f8d14fb","655":"ba370a3024245fa6092e"}[chunkId] + ".js";
};